module.exports = __webpack_public_path__ + "static/ss3-d75e537b310714889454f11019ff9875.png";